import type { SceneId } from '../../sim/types';
import { heronNest } from './heron';
import { ice } from './ice';
import { pond } from './pond';
import { storm } from './storm';
import { swamp } from './swamp';
import type { SceneArt } from './types';

export const SCENES: Record<SceneId, SceneArt> = { pond, swamp, storm, ice, heron: heronNest };
